import { useState } from 'react';

// CAPA DO VÍDEO NO CELULAR (#1271, cs2465).
//
// Os heros "Reserva" (busca:8) e "Autoral" (busca:11) desligam o <video> no mobile de
// propósito — um MP4 de fundo no 4G é dado e bateria do visitante. Quem tem banner cadastrado
// vê o banner; quem NÃO tem via um fundo liso, e o cliente lê isso como "o banner sumiu no
// celular". Esta capa (1 frame do próprio vídeo, ~30KB) ocupa esse lugar: a mesma cena do
// desktop, pelo preço de uma imagem.
//
// Se a capa não existir (vídeo antigo que o backfill não alcançou, ou upload em que a extração
// falhou), o onError devolve EXATAMENTE o fundo de antes — nunca o ícone de imagem quebrada.
type Props = {
    src?: string | null;
    className?: string;
    fallbackClassName?: string;
};

export default function HeroVideoCover({ src, className, fallbackClassName }: Props) {
    const [falhou, setFalhou] = useState(false);
    if (!src || falhou) {
        return <div className={fallbackClassName} />;
    }
    return (
        <img
            className={className}
            src={src}
            alt=""
            aria-hidden="true"
            decoding="async"
            onError={() => setFalhou(true)}
        />
    );
}
